import { defineComponent as l, createBlock as n, openBlock as r, unref as c, mergeProps as p, withCtx as m, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconController",
  __name: "IconController",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (r(), n(c(d), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        a("path", { d: "M15 9.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2m-1 3a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2m-5.5-3A.75.75 0 0 1 9.25 10v.75H10a.75.75 0 0 1 0 1.5H9.25V13a.75.75 0 0 1-1.5 0v-.75H7a.75.75 0 0 1 0-1.5h.75V10A.75.75 0 0 1 8.5 9.25" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M6.555 5.568a46.752 46.752 0 0 1 10.89 0c2.031.238 3.057 2.126 3.588 3.967.55 1.91.696 4.174.715 5.86.022 1.922-1.57 3.355-3.417 3.355a3.56 3.56 0 0 1-2.202-.763l-1.152-.907H9.023l-1.151.907a3.56 3.56 0 0 1-2.203.763c-1.846 0-3.438-1.433-3.417-3.355.02-1.686.164-3.95.715-5.86.53-1.84 1.557-3.73 3.588-3.967m10.716 1.49a45.251 45.251 0 0 0-10.541 0c-1.033.12-1.808 1.11-2.322 2.893-.494 1.713-.637 3.815-.656 5.461-.011 1.012.83 1.838 1.917 1.838a2.06 2.06 0 0 0 1.275-.442l1.355-1.067a.75.75 0 0 1 .464-.16h6.474a.75.75 0 0 1 .464.16l1.355 1.067a2.06 2.06 0 0 0 1.275.442c1.088 0 1.928-.826 1.917-1.838-.019-1.646-.162-3.748-.656-5.461-.514-1.782-1.29-2.772-2.321-2.893",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
